import React from 'react';
import ContentLoader from 'react-content-loader';
function ViewBoxLoader(_a) {
    var _b = _a.height, height = _b === void 0 ? 25 : _b, _c = _a.width, width = _c === void 0 ? 150 : _c;
    return (React.createElement(ContentLoader, { height: height, width: width, speed: 1, viewBox: "80 0 250 44", backgroundColor: "#f3f3f3", foregroundColor: "#ecebeb" },
        React.createElement("rect", { x: "53", y: "14", rx: "3", ry: "3", width: "180", height: "13" }),
        React.createElement("rect", { x: "53", y: "30", rx: "3", ry: "3", width: "10", height: "10" }),
        React.createElement("rect", { x: "67", y: "30", rx: "3", ry: "3", width: "74", height: "10" }),
        React.createElement("rect", { x: "219", y: "146", rx: "0", ry: "0", width: "0", height: "0" })));
}
export default ViewBoxLoader;
//# sourceMappingURL=ViewBoxLoader.js.map